import * as React from "react";
import type { SVGProps } from "react";
const SvgKey = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M15.5 7.5 19 4m2-2-2 2zm-9.61 9.61a5.501 5.501 0 0 1-3.881 9.415 5.5 5.5 0 0 1-3.897-1.637 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5zM15.5 7.5l3 3L22 7l-3-3z"
    />
  </svg>
);
export default SvgKey;
